import ApiService from "../api";

export default class ProdutoCatalogoService extends ApiService {

    constructor() {
        super('/api/solicitacoes/config/produtos')
    }

    listar() {
        return this.get("");
    }

    listarAtivos() {
        return this.get("/ativos");
    }

    autocomplete(termo) {
        return this.get(`/autocomplete?search=${encodeURIComponent(termo)}`);
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }
}
